/**
 * Coordination between the two double-ESC listeners that can coexist on the
 * dashboard: the project-tree "reset view" handler and the app-wide
 * "switch status back to Working" hook (use-esc-status-reset). The toast
 * store keeps only ONE toast, so when both are mounted the view handler owns
 * all user feedback (it words its toasts to cover the status too) and the
 * status hook stays silent while still performing the PATCH.
 */
let viewResetOwners = 0;

export function registerViewResetOwner(): () => void {
  viewResetOwners += 1;
  return () => { viewResetOwners = Math.max(0, viewResetOwners - 1); };
}

export function hasViewResetOwner(): boolean {
  return viewResetOwners > 0;
}
